import { createSlice } from "@reduxjs/toolkit";
import { getQuestionForPractice, setSelectedSection } from "../actions/questionActionsHelper";
import { questionsObject } from "../stateObject/questionsObject";

const initialState = questionsObject;

const questionSlice = createSlice({
    name: "question",
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.isLoading = action.payload;
        },
        clearError: (state) => {
            state.error = null;
        },
        resetState: () => {
            return initialState;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getQuestionForPractice.request, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getQuestionForPractice.success, (state, action) => {
                state.questionData = action.payload;
                state.isLoading = false;
                state.error = null;
            })
            .addCase(getQuestionForPractice.failed, (state, action) => {
                state.isLoading = false;
                state.error = action.payload || "Failed to fetch practice question. Please try again.";
            })
            .addCase(setSelectedSection.request, (state, action) => {
                state.selectedSection = action.payload;
            });
    },
});

export const { setLoading, clearError, resetState: resetQuestionState } = questionSlice.actions;
export default questionSlice.reducer;
